export default __webpack_public_path__ + "static/media/login.68266af6.svg";